import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { KeyValue } from '../models/key-value';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  public loading$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getOrganizations(): Observable<KeyValue[]> {
    return this.http.get<KeyValue[]>(
      `${environment.api}/Commons/organizations`,
      {
        headers: this.headers,
      }
    );
  }

  getDepartments(orgId: number): Observable<KeyValue[]> {
    return this.http.get<KeyValue[]>(
      `${environment.api}/Commons/departments/${orgId}`,
      {
        headers: this.headers,
      }
    );
  }

  getSubDepartments(deptId: number): Observable<KeyValue[]> {
    return this.http.get<KeyValue[]>(
      `${environment.api}/Commons/subDepartments/${deptId}`,
      {
        headers: this.headers,
      }
    );
  }

  getSecretLevels(): Observable<KeyValue[]> {
    return this.http.get<KeyValue[]>(
      `${environment.api}/Commons/secretLevels/`,
      {
        headers: this.headers,
      }
    );
  }
}
